import Model, { attr } from '@ember-data/model';

export default class PracticeWebsiteUploadModel extends Model {
  @attr() uploadType;
  @attr() uploadToken;
}
